export default {
  title: 'Partner',
  search_placeholder: 'Cerca partner...',
  buttons: {
    default_price_list: 'Listino prezzi predefinito',
    create_partner: 'Crea partner',
  },
  columns: {
    name: 'Nome',
    restaurants: 'Ristoranti',
    shop_domain: 'Dominio shop',
    status: 'Stato',
    earning_enabled: 'Guadagni abilitati',
  },
  statuses: {
    invited: 'Invitato',
    active: 'Attivo',
    suspended: 'Sospeso',
  },
  actions: {
    edit: 'Modifica',
    view_billing: 'Vedi fatturazione',
    view_as_partner: 'Visualizza come partner',
    suspend: 'Sospendi',
    unsuspend: 'Riattiva',
  },
  suspension: {
    suspend_title: 'Sospendere questo partner?',
    suspend_description:
      'Tutti i membri del team del partner saranno disattivati e le loro sessioni revocate. I loro ristoranti rimarranno attivi.',
    unsuspend_title: 'Riattivare questo partner?',
    unsuspend_description: 'Tutti i membri del team del partner saranno riattivati e potranno accedere nuovamente.',
  },
  toasts: {
    load_error: 'Impossibile caricare i partner.',
    suspended: 'Il partner è stato sospeso.',
    unsuspended: 'Il partner è stato riattivato.',
    suspension_error: 'Impossibile modificare lo stato del partner.',
    view_as_error: 'Impossibile aprire la dashboard del partner.',
  },
};
